import Footer from '../Footer/Footer';
import { useState } from 'react';
import Sidebar from '../SidebarSection/SideBar';
import Navbar from '../Header/Navbar';
import ProductList from './Product List Section/ProductList';
import HeruSection from './Heru Section/Heru';
import CartSidebar from '../Cart SideBar/CartSidebar';
import Instagram from '../../Common/Instagram Section/Instagram';


function ProductPage() {
   const [isOpen, setIsOpen] = useState(false);
  const [isOpenHeader, setIsOpenHeader] = useState(true);
  const [cartisOpen, setcartIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  
  const removeheader = () => {
    setIsOpenHeader(!isOpenHeader);
  };
  
  const carttoggle = () => {
      setcartIsOpen(!cartisOpen);
  };

  return (
    <div style={{display:'flex',flexDirection:"column",width:'100%'}}>
      <Navbar toggle={toggle} carttoggle={carttoggle} removeheader={removeheader} isOpenHeader={isOpenHeader}/>
      <CartSidebar isOpen={cartisOpen} toggle={carttoggle}/>
       <Sidebar isOpen={isOpen} toggle={toggle} />
       <HeruSection/>
        <ProductList/>
        <Instagram />
      <Footer />
    </div>
  );
}

export default ProductPage;
